export default __webpack_public_path__ + "static/media/net-banking-icon.6b114cc3.svg";